import { render, staticRenderFns } from "./ShipToAddressManagement.vue?vue&type=template&id=8def960a"
import script from "./ShipToAddressManagement.vue?vue&type=script&lang=js"
export * from "./ShipToAddressManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports